import axios from 'axios';

const FetchAddress = axios.create({
  baseURL: import.meta.env.VITE_API_GOUV_ADDRESS,
  headers: {
    Accept: '*/*'
  }
});


export default FetchAddress;
